import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";
import { userService } from "../services/userService";
import EmployeeSalaryManager from "../components/employee/EmployeeSalaryManager";

const EmployeeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        setLoading(true);
        // If it's one of the dummy IDs, skip fetching
        if (String(id).startsWith('dummy-')) {
          setEmployee({
            id,
            firstName: id.replace('dummy-', '').charAt(0).toUpperCase() + id.replace('dummy-', '').slice(1),
            lastName: "Employee",
            email: `${id.replace('dummy-', '')}@example.com`,
            designation: "Dummy Role",
            department: "Dummy Dept",
            enabled: true,
            managerUserId: "dummy-santosh",
            managerEmail: "santosh@example.com",
            subordinates: [
              { userId: "dummy-manish", email: "manish@example.com" },
              { userId: "dummy-divesh", email: "divesh@example.com" },
            ],
          });
          return;
        }

        const data = await userService.getById(id);
        setEmployee(data);
      } catch (err) {
        setError(err.userMessage || "Failed to load employee details.");
      } finally {
        setLoading(false);
      }
    };
    
    if (id) {
      fetchEmployee();
    }
  }, [id]);

  if (loading) {
    return <div className="p-6 text-gray-500">Loading employee details...</div>;
  }

  if (error || !employee) {
    return (
      <div className="p-6">
        <Button variant="ghost" onClick={() => navigate('/employees')} className="mb-4">
          <ArrowLeft className="mr-2 h-4 w-4" /> Back to Employees
        </Button>
        <div className="text-red-500">{error || "Employee not found"}</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <EmployeeSalaryManager
        employee={employee}
        onBack={() => navigate('/employees')}
        onEmployeeUpdate={(updated) => setEmployee((prev) => ({ ...prev, ...updated }))}
      />
    </div>
  );
};

export default EmployeeDetails;

